module.exports = __webpack_public_path__ + "static/media/image_8.46ced35f.png";